import React, { useState, useEffect } from 'react'
import axiosClient from 'api/axiosClient'
import { useParams } from 'react-router';
import { updateMenuSelected } from 'redux/actions/menu';
import { useDispatch, useSelector } from 'react-redux'
import Loader from "react-loader-spinner";
// ** import gallery
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/scss/image-gallery.scss";
import { IMAGE_BASE_URL } from 'utils/constants';

export default function ListImageStudent() {
    const { id } = useParams()
    const dispatch = useDispatch()
    const [listImage, setListImage] = useState([])
    const [loaded, setLoaded] = useState()
    const standardImage = (listImageArr) => {
        let imgArr = []
        listImageArr.map((item, index) => {
            const tempImg = {
                original: `${IMAGE_BASE_URL}/${item.image}`,
                thumbnail: `${IMAGE_BASE_URL}/${item.image}`
            }
            imgArr.push(tempImg)
        })
        return imgArr
    }
    const standardAlbum = (dataMenu) => {
        let menu = {
            id: 1,
            title: 'Student',
            type: "INCLUDE",
            path: '/student',
            children: [
            ]
        }
        dataMenu.map((item, index) => {
            let menuItem = {
                id: item.id,
                type: 'CUSTOM_MEDIA',
                title: item.name,
                path: `/list/imageStudent/${item.id}`
            }
            menu.children.push(menuItem)
        }
        )
        return menu
    }
    useEffect(() => {
        axiosClient.get(`/studentAlbum?unit=home`).then(res => {
            const albumMenu = standardAlbum(res.data)
            dispatch(updateMenuSelected(albumMenu, {},[]))
        }).catch(error => {
            console.error("Lỗi gọi API!", error)
        })
    }, [])
    useEffect(() => {
        // set loading to wait get data
        setLoaded(false)
        axiosClient.get(`/studentImage/${id}/album?page=1&size=25`).then(res => {
            setListImage(standardImage(res.data))
            setLoaded(true)
        }).catch(error => {
            console.error("Lỗi gọi API!", error)
        })
    }, [id])
    if (id === undefined) {
        return <div>None of image</div>
    }
    return (
        !loaded ? <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" /> :
            <div>
                <ImageGallery
                    items={listImage}
                    lazyLoad={true}
                />
            </div>
    )
}
